/* @flow */
import type { TrackAggregationKey } from './TrackAggregationKey';
import type { TrackSortingField } from './TrackSortingField';
import type { SortingParams } from './SortingParams';
import type { PaginationParams } from './PaginationParams';

export type TrackSearchParams = {
  filters?: {
    [TrackAggregationKey]: any[],
  },
  filtersMeta?: {
    [TrackAggregationKey]: {
      filter?: string | null,
      pagination?: number,
    },
  },
  excludeProductionMusic: boolean,
  sorting?: SortingParams<TrackSortingField>,
  pagination?: PaginationParams,
};

export const trackSearchParamsProps = [
  'filters',
  'filtersMeta',
  'excludeProductionMusic',
  'sorting',
  'pagination',
];
